import { BeneficiaryCountry } from '@seapoint/server/enums';
import {
  AT,
  BE,
  BG,
  CH,
  CY,
  CZ,
  DE,
  DK,
  EE,
  ES,
  FI,
  FlagComponent,
  FR,
  GB,
  GR,
  HR,
  HU,
  IE,
  IS,
  IT,
  LI,
  LT,
  LU,
  LV,
  MC,
  MT,
  NL,
  NO,
  PL,
  PT,
  RO,
  SE,
  SI,
  SK,
  SM,
} from 'country-flag-icons/react/1x1';

export const getBeneficiaryCountryDetails = (countryCode: BeneficiaryCountry) => {
  return countryDetailsMap[countryCode];
};

const countryDetailsMap: Record<BeneficiaryCountry, { name: string; flag: FlagComponent }> = {
  [BeneficiaryCountry.IE]: { name: 'Ireland', flag: IE },
  [BeneficiaryCountry.GB]: { name: 'United Kingdom', flag: GB },
  [BeneficiaryCountry.AT]: { name: 'Austria', flag: AT },
  [BeneficiaryCountry.BE]: { name: 'Belgium', flag: BE },
  [BeneficiaryCountry.BG]: { name: 'Bulgaria', flag: BG },
  [BeneficiaryCountry.HR]: { name: 'Croatia', flag: HR },
  [BeneficiaryCountry.CY]: { name: 'Cyprus', flag: CY },
  [BeneficiaryCountry.CZ]: { name: 'Czech Republic', flag: CZ },
  [BeneficiaryCountry.DK]: { name: 'Denmark', flag: DK },
  [BeneficiaryCountry.EE]: { name: 'Estonia', flag: EE },
  [BeneficiaryCountry.FI]: { name: 'Finland', flag: FI },
  [BeneficiaryCountry.FR]: { name: 'France', flag: FR },
  [BeneficiaryCountry.DE]: { name: 'Germany', flag: DE },
  [BeneficiaryCountry.GR]: { name: 'Greece', flag: GR },
  [BeneficiaryCountry.HU]: { name: 'Hungary', flag: HU },
  [BeneficiaryCountry.IT]: { name: 'Italy', flag: IT },
  [BeneficiaryCountry.LV]: { name: 'Latvia', flag: LV },
  [BeneficiaryCountry.LT]: { name: 'Lithuania', flag: LT },
  [BeneficiaryCountry.LU]: { name: 'Luxembourg', flag: LU },
  [BeneficiaryCountry.MT]: { name: 'Malta', flag: MT },
  [BeneficiaryCountry.NL]: { name: 'Netherlands', flag: NL },
  [BeneficiaryCountry.PL]: { name: 'Poland', flag: PL },
  [BeneficiaryCountry.PT]: { name: 'Portugal', flag: PT },
  [BeneficiaryCountry.RO]: { name: 'Romania', flag: RO },
  [BeneficiaryCountry.SK]: { name: 'Slovakia', flag: SK },
  [BeneficiaryCountry.SI]: { name: 'Slovenia', flag: SI },
  [BeneficiaryCountry.ES]: { name: 'Spain', flag: ES },
  [BeneficiaryCountry.SE]: { name: 'Sweden', flag: SE },
  [BeneficiaryCountry.CH]: { name: 'Switzerland', flag: CH },
  [BeneficiaryCountry.IS]: { name: 'Iceland', flag: IS },
  [BeneficiaryCountry.LI]: { name: 'Liechtenstein', flag: LI },
  [BeneficiaryCountry.MC]: { name: 'Monaco', flag: MC },
  [BeneficiaryCountry.NO]: { name: 'Norway', flag: NO },
  [BeneficiaryCountry.SM]: { name: 'San Marino', flag: SM },
};
